import { localFileExt } from '../components/flow/constants';
import { encode } from 'js-base64';

export const pickLocalLibflow = () => {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';

    input.multiple = false;
    input.style.display = 'none';

    input.onchange = (e) => {
      const files = e.target.files;
      const slicedFiles = files ? Array.prototype.slice.call(files, 0) : [];
      if (slicedFiles.length) {
        const file = slicedFiles[0];
        const ext = file.name.split('.').pop();
        if (localFileExt !== ext) resolve({ code: -1, message: `文件格式不支持:${file.name}` });
        resolve({ code: 0, data: file });
      } else {
        resolve({ code: -1, message: `文件格式异常` });
      }
    };
    input.click();
  });
};

export const exportJsonAsFile = (data = {}, name = `def.${localFileExt}`) => {
  const json = encode(JSON.stringify(data, null, 2));
  let blob = new Blob([json], { type: 'application/json' });
  let link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = name;
  link.click();
};
